import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { ACTION_FA, faDateTime } from './labels'

/**
 * Who went where, and who let them.
 *
 * Filtered to actions about *reach* rather than content: entering a charity,
 * appointing staff, granting access. A row with «به‌جای مؤسسه» names the staff
 * account that was actually at the keyboard, which is the whole reason
 * `acting_user_id` exists.
 */
export function TrailTab() {
  const trail = useQuery({ queryKey: ['admin-trail'], queryFn: api.adminTrail })

  return (
    <div className="card">
      <h2>سابقهٔ دسترسی‌ها</h2>
      <p className="meta">
        این فهرست پاک نمی‌شود. اگر مؤسسه‌ای بپرسد چه کسی و کِی وارد حسابش شده، جواب همین‌جاست.
      </p>

      {trail.isLoading && <p className="muted">در حال بارگذاری…</p>}
      {trail.data && trail.data.entries.length === 0 && (
        <p className="muted">هنوز چیزی ثبت نشده است.</p>
      )}

      {trail.data && trail.data.entries.length > 0 && (
        <div className="table-scroll">
          <table className="table">
            <thead>
              <tr>
                <th>کِی</th>
                <th>چه کاری</th>
                <th>مؤسسه</th>
                <th>چه کسی</th>
              </tr>
            </thead>
            <tbody>
              {trail.data.entries.map((entry) => (
                <tr key={entry.id}>
                  <td>{faDateTime(entry.createdOn)}</td>
                  <td>{ACTION_FA[entry.action] ?? entry.action}</td>
                  <td>{entry.orgName ?? '—'}</td>
                  <td>
                    <div className="ltr">{entry.userEmail ?? '—'}</div>
                    {entry.actingEmail && entry.actingEmail !== entry.userEmail && (
                      <div className="meta">
                        به‌جای مؤسسه، با حساب <span className="ltr">{entry.actingEmail}</span>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
